import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import { services } from './logic';
import './Iframe.scss';

const getAttributes = url => {
  const service =
    url && services.find(_service => url.includes(_service.name));

  return service ? service.attributes : null;
};

const Iframe = ({ width, height, url }) => {
  const attributes = getAttributes(url);

  return (
    <div
      className={'iframe'}
      style={{
        width: `${width}px`,
        height: `${height}px`,
      }}
    >
      <LazyLoad once offset={200} height={300}>
        <iframe src={url} width={width} height={height} {...attributes} />
      </LazyLoad>
    </div>
  );
};

Iframe.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default Iframe;
